import React, { useState, useEffect } from "react";
import { Box, Card, CardContent, Typography, IconButton, Fade } from "@mui/material";
import { FacebookRounded, Instagram, YouTube, PublicOutlined } from "@mui/icons-material";

// Lista de 338 versículos (ejemplo con algunos, puedes expandirla)
const versiculos = [
    { libro: "Génesis", capitulo: 1, versiculo: 1 },
    { libro: "Éxodo", capitulo: 20, versiculo: 13 },
    { libro: "Levítico", capitulo: 19, versiculo: 18 },
    { libro: "Números", capitulo: 6, versiculo: 24 },
    { libro: "Deuteronomio", capitulo: 6, versiculo: 5 },
    { libro: "Josué", capitulo: 1, versiculo: 9 },
    { libro: "Jueces", capitulo: 5, versiculo: 31 },
    { libro: "Rut", capitulo: 1, versiculo: 16 },
    { libro: "1 Samuel", capitulo: 16, versiculo: 7 },
    { libro: "2 Samuel", capitulo: 22, versiculo: 2 },
    { libro: "1 Reyes", capitulo: 8, versiculo: 61 },
    { libro: "2 Reyes", capitulo: 2, versiculo: 11 },
    { libro: "1 Crónicas", capitulo: 16, versiculo: 11 },
    { libro: "2 Crónicas", capitulo: 7, versiculo: 14 },
    { libro: "Esdras", capitulo: 7, versiculo: 10 },
    { libro: "Nehemías", capitulo: 8, versiculo: 10 },
    { libro: "Ester", capitulo: 4, versiculo: 14 },
    { libro: "Job", capitulo: 1, versiculo: 21 },
    { libro: "Salmos", capitulo: 23, versiculo: 1 },
    { libro: "Proverbios", capitulo: 3, versiculo: 5 },
    { libro: "Eclesiastés", capitulo: 3, versiculo: 1 },
    { libro: "Cantares", capitulo: 2, versiculo: 4 },
    { libro: "Isaías", capitulo: 40, versiculo: 31 },
    { libro: "Jeremías", capitulo: 29, versiculo: 11 },
    { libro: "Lamentaciones", capitulo: 3, versiculo: 22 },
    { libro: "Ezequiel", capitulo: 36, versiculo: 26 },
    { libro: "Daniel", capitulo: 6, versiculo: 10 },
    { libro: "Oseas", capitulo: 6, versiculo: 6 },
    { libro: "Joel", capitulo: 2, versiculo: 28 },
    { libro: "Amós", capitulo: 5, versiculo: 24 },
    { libro: "Abdías", capitulo: 1, versiculo: 15 },
    { libro: "Jonás", capitulo: 2, versiculo: 2 },
    { libro: "Miqueas", capitulo: 6, versiculo: 8 },
    { libro: "Nahúm", capitulo: 1, versiculo: 7 },
    { libro: "Habacuc", capitulo: 2, versiculo: 4 },
    { libro: "Sofonías", capitulo: 3, versiculo: 17 },
    { libro: "Hageo", capitulo: 2, versiculo: 9 },
    { libro: "Zacarías", capitulo: 4, versiculo: 6 },
    { libro: "Malaquías", capitulo: 3, versiculo: 10 },
    { libro: "S. Mateo", capitulo: 5, versiculo: 16 },
    { libro: "S. Marcos", capitulo: 12, versiculo: 30 },
    { libro: "S. Lucas", capitulo: 1, versiculo: 37 },
    { libro: "S.Juan", capitulo: 3, versiculo: 16 },
    { libro: "Hechos", capitulo: 1, versiculo: 8 },
    { libro: "Romanos", capitulo: 8, versiculo: 28 },
    { libro: "1 Corintios", capitulo: 13, versiculo: 4 },
    { libro: "2 Corintios", capitulo: 5, versiculo: 17 },
    { libro: "Gálatas", capitulo: 5, versiculo: 22 },
    { libro: "Efesios", capitulo: 2, versiculo: 8 },
    { libro: "Filipenses", capitulo: 4, versiculo: 13 },
    { libro: "Colosenses", capitulo: 3, versiculo: 23 },
    { libro: "1 Tesalonicenses", capitulo: 5, versiculo: 18 },
    { libro: "2 Tesalonicenses", capitulo: 3, versiculo: 3 },
    { libro: "1 Timoteo", capitulo: 4, versiculo: 12 },
    { libro: "2 Timoteo", capitulo: 3, versiculo: 16 },
    { libro: "Tito", capitulo: 2, versiculo: 11 },
    { libro: "Filemón", capitulo: 1, versiculo: 7 },
    { libro: "Hebreos", capitulo: 11, versiculo: 1 },
    { libro: "Santiago", capitulo: 1, versiculo: 5 },
    { libro: "1 Pedro", capitulo: 5, versiculo: 7 },
    { libro: "2 Pedro", capitulo: 3, versiculo: 9 },
    { libro: "1 Juan", capitulo: 4, versiculo: 18 },
    { libro: "2 Juan", capitulo: 1, versiculo: 6 },
    { libro: "3 Juan", capitulo: 1, versiculo: 4 },
    { libro: "Judas", capitulo: 1, versiculo: 24 },
    { libro: "Apocalipsis", capitulo: 21, versiculo: 4 },
  ];

const LogoVersiculo = () => {
  const [mostrarLogo, setMostrarLogo] = useState(true);
  const [versiculoActual, setVersiculoActual] = useState("");
  const [cargando, setCargando] = useState(false);

  // Función para obtener un versículo aleatorio
  const obtenerVersiculoAleatorio = () => {
    const indiceAleatorio = Math.floor(Math.random() * versiculos.length);
    return versiculos[indiceAleatorio];
  };

  // Función para obtener el ID del libro
  const obtenerIdLibro = async (nombreLibro) => {
    try {
      const respuesta = await fetch(
        "https://ajphchgh0i.execute-api.us-west-2.amazonaws.com/dev/api/books"
      );
      const libros = await respuesta.json();
      const libroEncontrado = libros.find(
        (libro) => libro.name === nombreLibro
      );
      return libroEncontrado ? libroEncontrado.id : null;
    } catch (error) {
      console.error("Error al obtener el ID del libro:", error);
      return null;
    }
  };

  // Función para consultar el versículo en la API
  const consultarVersiculo = async (versiculo) => {
    const { libro, capitulo, versiculo: vers } = versiculo;
    setCargando(true); // Iniciar carga

    try {
      const idLibro = await obtenerIdLibro(libro);
      if (!idLibro) {
        throw new Error("Libro no encontrado: " + libro);
      }

      const url = `https://ajphchgh0i.execute-api.us-west-2.amazonaws.com/dev/api/books/${idLibro}/verses/${capitulo}:${vers}`;
      const respuesta = await fetch(url);
      const datos = await respuesta.json();
      setVersiculoActual(datos[0].cleanText + " - " + libro + " " + capitulo + ":" + vers);

    } catch (error) {
      console.error("Error al consultar el versículo:", error);
      setVersiculoActual("¡Más que una radio, una bendición!"); // Mensaje de error
    } finally {
      setCargando(false); // Finalizar carga
    }
  };

  // Efecto para cambiar entre el logo y el versículo cada 5 minutos
  useEffect(() => {
    const intervalo = setInterval(() => {
      setMostrarLogo((prev) => !prev); // Cambia entre true y false cada 5 minutos
      if (!mostrarLogo) {
        setTimeout(() => {
            const versiculoAleatorio = obtenerVersiculoAleatorio();
            consultarVersiculo(versiculoAleatorio);
        }, 1000);
        const versiculoAleatorio = obtenerVersiculoAleatorio();
        consultarVersiculo(versiculoAleatorio); // Consulta un versículo aleatorio
      }
    }, 60000); // 300000 ms = 5 minutos

    return () => clearInterval(intervalo); // Limpia el intervalo al desmontar el componente
  }, [mostrarLogo]);

  // Efecto para cargar un versículo aleatorio al inicio
  useEffect(() => {
    const versiculoAleatorio = obtenerVersiculoAleatorio();
    consultarVersiculo(versiculoAleatorio);
  }, []);

  return (
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "70%", maxWidth: 340 }}>
      <Card sx={{ width: "100%", boxShadow: 0, bgcolor: "transparent", padding: 2 }}>
        {/* Contenedor del logo o versículo */}
        <Box
          sx={{
            borderRadius: 6,
            boxShadow: 8,
            bgcolor: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: 200, // Altura mínima
            padding: 2,
            position: "relative", // Necesario para superponer los elementos
            overflow: "hidden", // Para evitar desbordamientos durante la transición
          }}
        >
          {/* Transición para el logo */}
          <Fade in={mostrarLogo} timeout={1000}>
            <Box
              sx={{
                position: "absolute", // Superpone el logo
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 2,
              }}
            >
              <img
                src="/logo512sf.png"
                alt="Logo"
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
              />
            </Box>
          </Fade>

          {/* Transición para el versículo */}
          <Fade in={!mostrarLogo && !cargando} timeout={1000}>
            <Box
              sx={{
                position: "absolute", // Superpone el versículo
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 2,
                height: "auto", // Ajusta la altura automáticamente
              }}
            >
              <Typography
                variant="h6"
                align="center"
                sx={{ fontStyle: "italic", color: "#000" }}
              >
                {versiculoActual}
                {/* <span dangerouslySetInnerHTML={{ __html: versiculoActual }} /> */}
              </Typography>
            </Box>
          </Fade>
        </Box>

        <CardContent>
          <Typography style={{ color: '#fff' }} variant="h4" align="center" gutterBottom>
            <b>Embajadores Stereo</b>
          </Typography>
          <Typography variant="subtitle1" align="center" color="rgba(255, 255, 255, 0.7)">
            En vivo desde Chinú, Córdoba
          </Typography>
        </CardContent>
      </Card>

      {/* Iconos de redes sociales */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          width: "100%",
          "& .MuiSvgIcon-root": {
            color: "rgba(255, 255, 255, 0.7)",
          },
        }}
      >
        <IconButton onClick={() => window.open("https://www.facebook.com/embajadores.gr")}>
          <FacebookRounded />
        </IconButton>
        <IconButton onClick={() => window.open("https://www.instagram.com/embajadores.gr/")}>
          <Instagram />
        </IconButton>
        <IconButton onClick={() => window.open("https://www.youtube.com/@embajadoresdelgrarey")}>
          <YouTube />
        </IconButton>
        <IconButton onClick={() => window.open("https://www.embajadoresdelgranrey.com")}>
          <PublicOutlined />
        </IconButton>
      </Box>
    </Box>
  );
};

export default LogoVersiculo;